import { appEntry } from '@/mocks/homeData';

export default function AppEntry() {
  return (
    <section id="app" className="w-full py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 bg-background-50 rounded-2xl p-6 md:p-10 border border-background-200/70">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-4">
              {appEntry.title}
            </h2>
            <p className="text-sm text-foreground-600 leading-relaxed mb-5">
              {appEntry.desc}
            </p>
            <div className="flex flex-wrap gap-2 justify-center lg:justify-start mb-6">
              {appEntry.features.map((f) => (
                <span
                  key={f}
                  className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-secondary-100 text-secondary-700 text-xs font-medium rounded-full whitespace-nowrap"
                >
                  <i className="ri-check-line text-secondary-500"></i>
                  {f}
                </span>
              ))}
            </div>
            <div className="inline-flex items-center gap-3 px-6 py-3 bg-foreground-900 text-background-50 rounded-xl font-medium text-sm cursor-pointer whitespace-nowrap">
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-download-2-line"></i>
              </span>
              立即下载 App
            </div>
          </div>
          <div className="flex items-center gap-6">
            <div className="w-32 h-32 bg-background-100 rounded-xl p-2 flex-shrink-0">
              <img
                src={appEntry.qrImage}
                alt="久播影院 App 下载二维码"
                className="w-full h-full object-contain"
                onError={(e) => {
                  (e.target as HTMLElement).style.display = 'none';
                }}
              />
            </div>
            <div className="hidden sm:block w-40 flex-shrink-0">
              <img
                src={appEntry.previewImage}
                alt="久播影院 App 界面预览"
                className="w-full h-auto rounded-xl object-cover"
                onError={(e) => {
                  (e.target as HTMLElement).style.display = 'none';
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}